<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-buttons-hidden @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalCommentsVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(disabled v-model="newRecord.comments")

</template>

<script>
// import { required, minLength, email } from 'vuelidate/lib/validators' // Ver documentacion
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalComments',
  props: {
    newRecord: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    priority: [
      {
        text: 'Normal',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Urgente',
        value: 2,
        color: 'primary'
      }
    ],
    columns: [
      // Agrega las columnas a mostrar
      'comments'
    ]
  }),
  validations: {
    newRecord: {
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalCommentsVisible'
    ]),
    getTitle () {
      return 'Comentarios'
    }
  },
  methods: {
    ...mapActions([
      'setModalCommentsVisible'
    ]),
    close () {
      this.setModalCommentsVisible(false)
    }
  }
}
</script>

<style lang="scss">
  .vm-table--tbody-table {
    min-width: 0 !important;
  }
  .vm-table--header {
    padding: 0 !important;
  }
</style>
